import "../incident.css";
import { ICustomerRisk, IncidentStatus, RISK_META, STATUS_META } from "../models/IIncident";

/**
 * Sipariş kartındaki müşteri risk rozeti. `risk` yoksa (hesaplanamadı = "bilinmiyor") hiçbir şey
 * gösterilmez; `None` (temiz) de gösterilmez — kartları kalabalıklaştırmasın.
 */
export function RiskBadge({ risk, onClick }: { risk?: ICustomerRisk | null; onClick?: () => void }) {
  if (!risk || risk.level === "None") return null;
  const m = RISK_META[risk.level] ?? RISK_META.Info;
  return (
    <span
      className="inc-badge"
      style={{ background: m.bg, color: m.color, cursor: onClick ? "pointer" : "default" }}
      title={`Müşteri geçmişi: son 3 ayda ${risk.distinctOrderCount} ayrı siparişte olay bildirildi`}
      onClick={onClick ? (e) => { e.stopPropagation(); onClick(); } : undefined}
    >
      <i className={`bi ${m.icon}`}></i>{m.label} · {risk.distinctOrderCount}
    </span>
  );
}

export function StatusBadge({ status }: { status: IncidentStatus }) {
  const m = STATUS_META[status] ?? STATUS_META.Confirmed;
  return (
    <span className="inc-badge" style={{ background: m.bg, color: m.color }}>
      <i className={`bi ${m.icon}`}></i>{m.label}
    </span>
  );
}

export const formatDateTime = (iso?: string) =>
  iso ? new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export const formatDay = (d?: string) =>
  d ? new Date(`${d}T12:00:00`).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }) : "—";
